import {
  calculateFinances,
  UserData,
  calculateSipFutureValue,
  formatRupeeLiteral,
} from '../../../constants';

const TwodaySalary = {
  label: 'Invest just 2 days a month ',
  sections: [
    {
      type: 'text',
      text: (user: UserData) => {
        const taxData = calculateFinances(user);
        const twoDaySalary = Math.max(
          Math.round(taxData.netTaxableSalary / 180 / 1000) * 1000,
          2000
        );
        const futureValue = calculateSipFutureValue(twoDaySalary, 25, 15);
        return `
        <br /><h5>
          ${
            user.firstName ? `${user.firstName}, ` : ''
          } invest Rs. ${twoDaySalary} per month
          & ${
            twoDaySalary >= 3000
              ? 'become a crorepati!'
              : 'achieve your future dreams!'
          }<br />
          This is just 2 days of your income every month.
        </h5><br />
        <p class="light"><small>
          Rs. ${twoDaySalary.toLocaleString('en-IN')} = 2 days' income
          &nbsp;
          <img height="12" src="https://assets1.cleartax-cdn.com/clearsave/images/right-green-arrow.svg" />
          &nbsp;
          15-18% Returns per year
          &nbsp;
          <img height="12" src="https://assets1.cleartax-cdn.com/clearsave/images/right-green-arrow.svg" />
          &nbsp;
          Rs. ${formatRupeeLiteral(futureValue)} in 25 years.
          </small>
        </p>`;
      },
    },
    {
      type: 'text',
      text: (user: UserData) => {
        const taxData = calculateFinances(user);
        const twoDaySalary = Math.max(
          Math.round(taxData.netTaxableSalary / 180 / 1000) * 1000,
          2000
        );
        const data8 = calculateSipFutureValue(twoDaySalary, 8, 15);
        const data16 = calculateSipFutureValue(twoDaySalary, 16, 15);
        const data25 = calculateSipFutureValue(twoDaySalary, 25, 15);
        return `
          <div class="data-points-graph">
            <img class="full-width" src="https://assets1.cleartax-cdn.com/clearsave/images/g1.svg" />
            <div class="graph-data-8">${formatRupeeLiteral(data8)}</div>
            <div class="graph-data-16">${formatRupeeLiteral(data16)}</div>
            <div class="graph-data-25">${formatRupeeLiteral(data25)}</div>
            <div class="graph-prediction">
              <div class="top-box">
                <div class="left-box">
                  <label>Total Investment</label>
                  <p>${formatRupeeLiteral(
                    twoDaySalary * 12 * taxData.aggressiveYears
                  )}</p>
                </div>
                <div class="middle-arrow">
                  <img src="https://assets1.cleartax-cdn.com/clearsave/images/right-green-arrow.svg" />
                </div>
                <div class="right-box">
                  <label>You get</label>
                  <p>${formatRupeeLiteral(data25)}</p>
                </div>
              </div>
              <div class="bottom-box">Your Profit ${formatRupeeLiteral(
                data25 - twoDaySalary * 12 * taxData.aggressiveYears
              )}</div>
            </div>
          </div>
        `;
      },
    },
  ],
};

export default TwodaySalary;



// WEBPACK FOOTER //
// ./components/recommendation/cards/twoDaysalary.ts